import I18n from "i18n-js";

window.I18n = I18n;

require("../bundles/i18n/lv.js");
require("../bundles/i18n/lt.js");
require("../bundles/i18n/en.js");
require("../bundles/i18n/ru.js");
require("../bundles/i18n/ee.js");

function getCurrentLocale() {
  if (document.body && document.body.dataset) {
    const locale = document.body.dataset.locale;
    if (locale) {
      return locale;
    }
  }

  if (typeof $ !== "undefined" && $("body").length) {
    const locale = $("body").data("locale");
    if (locale) {
      return locale;
    }
  }

  const urlParams = new URLSearchParams(window.location.search);
  const urlLocale = urlParams.get("locale");
  if (urlLocale) {
    return urlLocale;
  }

  return "en";
}

function getDefaultLocale() {
  if (document.body && document.body.dataset) {
    const defaultLocale = document.body.dataset.defaultLocale;
    if (defaultLocale) {
      return defaultLocale;
    }
  }
  
  if (typeof $ !== "undefined" && $("body").length) {
    const defaultLocale = $("body").data("default-locale");
    if (defaultLocale) {
      return defaultLocale;
    }
  }
  
  return "en";
}

function initializeI18n() {
  I18n.locale = getCurrentLocale();
  I18n.defaultLocale = getDefaultLocale();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeI18n);
} else {
  initializeI18n();
}

if (typeof $ !== "undefined") {
  $(document).on('turbolinks:load', initializeI18n);
}

export function t(key, i18nNamespace = "", options = {}) {
  I18n.locale = getCurrentLocale();
  I18n.defaultLocale = getDefaultLocale();
  const fullKey = i18nNamespace ? `${i18nNamespace}.${key}` : key;
  return I18n.t(fullKey, options);
}

window.t = t;
